import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  //const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'; // Simplified login check
  const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true'; // Simplified login check

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect to="/Admin"/> // Redirect to the login/home page if not logged in
        )
      }
    />
  );
};

export default ProtectedRoute;
